import { combineEpics } from 'redux-observable';
import { getRostersEpic } from './get-rosters';
import { createRosterEpic } from './create-roster';
import { deleteRosterEpic } from './delete-roster';
import { updateRosterEpic } from './update-roster';
import { attachArtistRosterEpic } from './attach-artist-roster';
import { removeArtistRosterEpic } from './remove-artist-roster';
import { updateRosterRelationEpic } from './update-roster-relation';
import { listRosterOperatorsEpic } from './list-roster-operators';
import { listRosterArtistsEpic } from './list-roster-artists';
import { createRosterOperatorEpic } from './create-roster-operator';
import { deleteRosterOperatorEpic } from './delete-roster-operator';
import { listArtistsAfterLoadEpic } from './list-artists-after-load';
import { attachArtistAfterCreateRosterEpic } from './attach-artists-new-roster';
import { attachArtistAfterUpdateRosterEpic } from './attach-artists-update-roster';

const rostersEpic = combineEpics(
  getRostersEpic,
  createRosterEpic,
  deleteRosterEpic,
  updateRosterEpic,
  attachArtistRosterEpic,
  removeArtistRosterEpic,
  listRosterArtistsEpic,
  updateRosterRelationEpic,
  listRosterOperatorsEpic,
  createRosterOperatorEpic,
  deleteRosterOperatorEpic,
  listArtistsAfterLoadEpic,
  attachArtistAfterCreateRosterEpic,
  attachArtistAfterUpdateRosterEpic
);

export default rostersEpic;
